import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
//const jwtDecode = require("jwt-decode");

const ProtectedRoute = ({ children }) => {
  const [isClient, setIsClient] = useState(false);

  // Set the client-side flag after component mounts
  useEffect(() => {
    setIsClient(true);
  }, []);

  const token = localStorage.getItem("token");

  // Render nothing until we're sure it's running client-side
  if (!isClient) {
    return null;
  }
  console.log("token in protecte droute sssssss", token);
  // If token exists, render the child components (the protected route)
  if (token) {
    try {
      const decoded = jwtDecode(token);
      if (Date.now() >= decoded.exp * 1000) {
        return <Navigate to="/" />;
      }

      return children;
    } catch (error) {
      console.error("Invalid token:", error);
      return <Navigate to="/" />;
    }
  }

  return <Navigate to="/" />;
};

export default ProtectedRoute;
